import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { Store } from '@ngrx/store';
import { CarMake } from 'src/app/public/car/models/car-make.model';
import { CarManufacturer } from 'src/app/public/car/models/car-manufacturer.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';


@Component({
    selector: 'app-carref-makes',
    templateUrl: './carref-makes.component.html',
    styleUrl: './carref-makes.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarrefMakesComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() manufacturers: CarManufacturer[] = [];
  @Input() makes: CarMake[] = [];

  newItem: CarMake = new CarMake('', '', 0);
  editedItem: CarMake = new CarMake('', '', 0);

  displayedColumns: string[] = ['id', 'name','manufacturerName', 'lastUpdated', 'actions'];
  dataSource = new MatTableDataSource<CarMake>(this.makes);

  @ViewChild(MatPaginator) paginator! : MatPaginator;
  @ViewChild(MatSort) sort! : MatSort;

  editingItemId: number = 0;
  editingItem: boolean = false;

  constructor(
    private store: Store){
  
  }

  ngOnInit(){
    this.store.dispatch (CarRefActions.makesFetchSubmit({}));
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['makes']){
      this.dataSource.data = changes['makes'].currentValue;
      
    }
  }

  applyFilter(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }
  
  addNewRow(){
    //const newManuf = new CarMake('','',false);
    if(! (this.editingItem  && this.editingItemId === 0)){
      this.editedItem = new CarMake('','', 0);
      this.dataSource.data = [...this.dataSource.data, new CarMake('','', 0)];
      this.editingItemId = 0;
      this.editingItem = true;
    }
    
  }

  editItem(id: number){
    this.editingItemId = id;
    this.editingItem = true;
    //console.log(this.makes.find((manuf: CarMake) => manuf.id === id));
    this.editedItem = Object.assign({}, this.editedItem, this.makes.find((item: CarMake) => item.id === id) );
    //console.log(this.editedItem);
  }

  SaveItem(id: number){
    this.editingItemId = 0;
    this.editingItem = false;
    //console.log(this.editedItem);
    //console.log(this.makes.find((manuf: CarMake) => manuf.id === id));
    this.editedItem = Object.assign({}, this.makes.find((manuf: CarMake) => manuf.id === id), this.editedItem);
    
    console.log(this.editedItem);
  
    if(id===0){
      this.store.dispatch (CarRefActions.makeNewSubmit({make: this.editedItem }));
    } else{
      this.editedItem.id=id;
      console.log(this.editedItem);
      this.store.dispatch (CarRefActions.makeUpdateSubmit({make: this.editedItem }));
    }
    
  }

  deleteItem(id: number){
    console.log(id)
    if(id ===0 || this.editingItem){
      this.dataSource.data = this.dataSource.data.filter(manuf => manuf.id !== 0);
      this.editingItem = false;
      this.editingItemId === 0
    }
      else{
        this.store.dispatch (CarRefActions.makeDeleteSubmit({makeId: id }));
    }
    
  }

  editedItemIsValid(): boolean{
    return this.editedItem.manufacturerId > 0 && this.editedItem.name.length > 0;
   }

  dateTimeFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

}
